<div class="row">
    <div class="col-12 col-md-4">
        <div class="card rounded-0" >
            <div class="card-body">
                <div *ngIf="!providers || providers.length == 0">
                    <h3 class="fs-4 fw-bold">Transfer Game</h3>
                    <p>No transfer API provider found. Please go to <a [routerLink]="['/lo', company_uuid, 'setting-integration']">Setting Integration</a> to integrate the game.</p>
                </div>
                <form #f="ngForm" (ngSubmit)="f.valid && submit()" novalidate *ngIf="providers && providers.length > 0">
                    <h3 class="fs-4 fw-bold">Transfer Game</h3>
                    <div class="mb-3">
                        <label for="title" class="form-label">Game Title <em>*</em></label>
                        <input type="text" class="form-control" id="title" name="title" #title="ngModel" [(ngModel)]="data.title" required autocomplete="off">
                        <div *ngIf="f.submitted && title.invalid" class="invalid-feedback">
                            <div *ngIf="title.errors.required">Game Title is required</div>
                        </div>
                    </div>
                   
                    <div class="mb-3">
                        <label for="provider" class="form-label">Transfer API Provider <em>*</em></label>
                        <select class="form-control" name="provider" #provider="ngModel" [(ngModel)]="data.integration_id" required (change)="checkIfCurrentProviderHaveCategory()">
                            <option [value]="provider.id" *ngFor="let provider of providers">{{provider.name}}</option>
                        </select>
                        <p class="mt-2" style="font-size:10px; line-height: 16px">Contact support for integrate the game.</p>
                    </div>

                    <div class="mb-3" >
                        <label for="logo" class="form-label">Image</label>
                        <app-image-uploader [type]="'single'" #imageUploader (deleteEvent)="removeImage()" (uploadEvent)="upload($event)"></app-image-uploader>
                    </div>

                    <div class="mb-3 border rounded p-2">
                        <div class="d-flex justify-content-between align-items-center mb-2">
                            <label class="form-label mb-0">Game Tile Images</label>
                            <div>
                                <button type="button" class="btn btn-sm btn-outline-secondary me-2" (click)="loadTiles()" [disabled]="tilesLoading || !data.uuid">
                                    {{ tilesLoading ? 'Loading…' : 'Load Tiles' }}
                                </button>
                                <button type="button" class="btn btn-sm btn-outline-primary" (click)="addImageRow()">+ Add</button>
                            </div>
                        </div>
                        <p class="text-muted" style="font-size:10px; line-height:14px">
                            Image shown for each game tile on the transfer-game page. Match by Game ID (preferred) or Name.
                            The <b>Default</b> image is the fallback; upload a language image only when it differs — the tile
                            uses the player's language image when present, otherwise the Default.
                            Use "Load Tiles" to auto-list this provider's games. Save the game first to enable it.
                        </p>

                        <div *ngIf="gameImages.length == 0" class="text-muted small mb-2">No tile images yet.</div>

                        <div class="row g-2 align-items-end mb-3 pb-2 border-bottom" *ngFor="let row of gameImages; let i = index">
                            <div class="col-12 col-md-4">
                                <label class="form-label small mb-1">Game ID</label>
                                <input type="text" class="form-control form-control-sm" name="gi_game_id_{{i}}" [(ngModel)]="row.game_id" autocomplete="off">
                            </div>
                            <div class="col-12 col-md-4">
                                <label class="form-label small mb-1">Name</label>
                                <input type="text" class="form-control form-control-sm" name="gi_name_{{i}}" [(ngModel)]="row.name" autocomplete="off">
                            </div>
                            <div class="col-10 col-md-3">
                                <label class="form-label small mb-1">Image (Default)</label>
                                <app-image-uploader [type]="'single'" [loadImage]="row.image" (uploadEvent)="onRowImage(i, $event)" (deleteEvent)="onRowImageDelete(i)"></app-image-uploader>
                            </div>
                            <div class="col-2 col-md-1">
                                <button type="button" class="btn btn-sm btn-outline-danger" (click)="removeImageRow(i)">×</button>
                            </div>
                            <div class="col-12">
                                <label class="form-label small mb-1 mt-1 d-block">Language images (optional — fall back to Default)</label>
                                <div class="row g-2">
                                    <div class="col-6 col-md-3" *ngFor="let lang of imageLangs">
                                        <label class="form-label small mb-1">{{ lang.title }}</label>
                                        <app-image-uploader [type]="'single'" [loadImage]="row.images && row.images[lang.code]" (uploadEvent)="onRowLangImage(i, lang.code, $event)" (deleteEvent)="onRowLangImageDelete(i, lang.code)"></app-image-uploader>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <div class="mb-3">
                                <label for="category_id" class="form-label">Category <em>*</em></label>
                                <select class="form-control" id="category_id" name="category_id" [(ngModel)]="data.category_id">
                                    <option [value]="t.id" *ngFor="let t of categories">{{t.title}}</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div class="mb-3">
                        <label for="android_link" class="form-label">Android Download Link <em>*</em></label>
                        <input type="text" class="form-control" id="android_link" name="android_link" [(ngModel)]="data.android_link" required autocomplete="off">
                    </div>

                    <div class="mb-3">
                        <label for="ios_link" class="form-label">IOS Download Link <em>*</em></label>
                        <input type="text" class="form-control" id="ios_link" name="ios_link" [(ngModel)]="data.ios_link" required autocomplete="off">
                    </div>

                    <div class="mb-3">
                        <label for="status" class="form-label">Status <em>*</em></label>
                        <select class="form-control" name="status" #status="ngModel" [(ngModel)]="data.status" required>
                            <option [value]="1">Active</option>
                            <option [value]="0">Disabled</option>
                        </select>
                        <div *ngIf="f.submitted && status.invalid" class="invalid-feedback">
                            <div *ngIf="status.errors.required">Status is required</div>
                        </div>
                    </div>

                    <div class="mb-3">
                        <label for="instruction" class="form-label">Game Play Instruction</label>
                        <quill-editor [format]="'html'" [(ngModel)]="data.instruction" [required]="true" [styles]="{minHeight: '250px'}" (onEditorCreated)="editorCreated($event, 'instruction')"></quill-editor>
                                <!-- <textarea rows="10" id="instruction" class="form-control" name="instruction" #instruction="ngModel" [(ngModel)]="data.instruction" ></textarea> -->
                    </div>
                    <div class="mb-3">
                        <label for="instruction_iframe" class="form-label">Game Play Instruction <small>(with iframe)</small></label>
                        <quill-editor [format]="'html'" [(ngModel)]="data.instruction_iframe" [required]="true" [styles]="{minHeight: '250px'}" (onEditorCreated)="editorCreated($event, 'instruction_iframe')"></quill-editor>
                        <!-- <textarea rows="10" id="instruction_iframe" class="form-control" name="instruction_iframe" #instruction_iframe="ngModel" [(ngModel)]="data.instruction_iframe" ></textarea> -->
                    </div>

                    <button type="submit" class="btn btn-primary">Update</button>
                </form>
            </div>
        </div>
    </div>
</div>
